import { faEdit, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ColumnDescription } from "react-bootstrap-table-next";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import SpinnerComponent from "../../../../../../Components/Loding/Spinner";
import Table from "../../../../../../Components/Table";
import {
    CadastrarFiltroAcaoEtapaController,
    DeletarFiltroAcaoEtapaController,
    ListarFiltrosAcaoEtapaController,
    ListarTipoFiltroAcaoEtapaController,
    EditarFiltroAcaoEtapaController,
} from "../../../../../../Controllers/Automacao/Regua/GestaoDeRegua/GestaoDeReguaControllers";
import {
    IReguaEtapaAcaoFiltro,
    IReguaEtapaAcaoTipoFiltro,
} from "../../../../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";
interface IProps {
    idAcaoEtapa: number;
}

interface IFormData {
    ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO: number;
    ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO?: any;
    ID_TIPO_FILTRO: number;
    DS_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO: string;
    DS_OPERADOR: string;
    DS_VALOR: string;
}

export default function ModalGerenciarFiltroAcao(props: IProps) {
    const [LstEtapaAcaoFiltro, setLstEtapaAcaoFiltro] =
        useState<Array<IReguaEtapaAcaoFiltro>>();
    const [LstEtapaAcaoTipoFiltro, setLstEtapaAcaoTipoFiltro] =
        useState<Array<IReguaEtapaAcaoTipoFiltro>>();
    const { register, handleSubmit, formState, reset, setValue } = useForm();
    const [isEditing, setIsEditing] = useState(false);
    const [editingFilter, setEditingFilter] = useState<IFormData | null>(null);

    useEffect(() => {
        console.log("editingFilter", editingFilter)
    }, [editingFilter])

    const updateList = useCallback(() => {
        ListarFiltrosAcaoEtapaController(props.idAcaoEtapa).then((res) => {
            setLstEtapaAcaoFiltro(res);
        });
        ListarTipoFiltroAcaoEtapaController().then((res) => {
            setLstEtapaAcaoTipoFiltro(res);
        });
    }, [props.idAcaoEtapa]);

    useEffect(() => {
        updateList();
    }, [updateList]);
    function handleFormSubmit(formData: IFormData) {
        CadastrarFiltroAcaoEtapaController({
            ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO: formData.ID_TIPO_FILTRO,
            DS_OPERACAO: formData.DS_OPERADOR,
            DS_VALOR: formData.DS_VALOR,
            ID_CASO_COBRANCA_REGUA_ETAPA_ACAO: props.idAcaoEtapa,
            ID_TIPO_FILTRO: formData.ID_TIPO_FILTRO,
        }).then(() => {
            updateList();
            handleEditCancel();
        });
    }

    function adicionarQuebraDeLinha(texto: string, maxCaracteres: number = 150): string {
        let resultado = '';
        for (let i = 0; i < texto.length; i += maxCaracteres) {
            resultado += texto.substring(i, i + maxCaracteres) + '<br />';
        }
        return resultado;
    }

    const rowTipoFiltro = (cell: any, row: IReguaEtapaAcaoFiltro) => {
        return <div>{row.DS_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO}</div>;
    };

    const rowOperador = (cell: any, row: IReguaEtapaAcaoFiltro) => {
        return <div>{row.DS_OPERACAO}</div>;
    };
    const rowValor = (cell: any, row: IReguaEtapaAcaoFiltro) => {
        return (
            <OverlayTrigger
                overlay={
                    row.DS_VALOR.length > 80 ? (
                        <Tooltip id="tooltip-disabled">{row.DS_VALOR}</Tooltip>
                    ) : (
                        <div></div>
                    )
                }
            >
                <div>
                    {row.DS_VALOR.length > 70
                        ? <div dangerouslySetInnerHTML={{ __html: adicionarQuebraDeLinha(row.DS_VALOR) }} />
                        : row.DS_VALOR}
                </div>
            </OverlayTrigger>
        );
    };

    const rowExcluir = (cell: any, row: IReguaEtapaAcaoFiltro) => {
        return (
            <div className="d-flex justify-content-center align-itens-center">
                <button
                    className="btn  btn-sm btn-outline-danger font-weight-bold"
                    onClick={() => {
                        Swal.fire({
                            title: "Deseja apagar este filtro?",
                            icon: "info",
                            buttonsStyling: false,
                            confirmButtonText:
                                "<i class='la la-check'></i> Sim!",
                            showCancelButton: true,
                            cancelButtonText:
                                "<i class='la la-thumbs-down'></i> Não",
                            customClass: {
                                confirmButton: "btn btn-outline-success",
                                cancelButton: "btn btn-default",
                            },
                        }).then((result) => {
                            if (result.isConfirmed) {
                                row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO &&
                                    DeletarFiltroAcaoEtapaController(
                                        row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO
                                    ).then(() => updateList());
                            }
                        });
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} size="lg" />
                </button>
            </div>
        );
    };

    const rowEditar = (cell: any, row: IReguaEtapaAcaoFiltro) => {
        return (
            <div className="d-flex justify-content-center align-itens-center">
                <button
                    className="btn btn-sm btn-outline-warning font-weight-bold"
                    onClick={() => {
                        console.log("row", row)
                        setEditingFilter({
                            ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO: row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO,
                            ID_TIPO_FILTRO: row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO ?? 0,
                            DS_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO: row.DS_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO || '',
                            DS_VALOR: row.DS_VALOR || '',
                            DS_OPERADOR: row.DS_OPERACAO || '',
                            ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO: row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO ?? 0,
                        });
                        setIsEditing(true);
                    }}
                >
                    <FontAwesomeIcon icon={faEdit} size="lg" />
                </button>
            </div>
        );
    };

    const columns: Array<ColumnDescription> = [
        {
            dataField: "ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO",
            text: "Tipo Filtro",
            formatter: rowTipoFiltro,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
        },
        {
            dataField: "ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO",
            text: "Operação",
            formatter: rowOperador,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
        },
        {
            dataField: "ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO",
            text: "Valor",
            formatter: rowValor,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
        },
        {
            dataField: "ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO",
            text: "Editar",
            formatter: rowEditar,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
        },
        {
            dataField: "ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO",
            text: "Excluir",
            formatter: rowExcluir,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
        },
    ];

    const handleEditConfirm = () => {
        if (editingFilter) {
            EditarFiltroAcaoEtapaController({
                ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO: editingFilter.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO,
                ID_TIPO_FILTRO: editingFilter.ID_TIPO_FILTRO,
                DS_OPERACAO: editingFilter.DS_OPERADOR,
                DS_VALOR: editingFilter.DS_VALOR,
                ID_CASO_COBRANCA_REGUA_ETAPA_ACAO: props.idAcaoEtapa,
                ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO: editingFilter.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO,
            }).then(() => {
                updateList();
                setIsEditing(false);
                setEditingFilter(null);
            });
        }
    };

    const handleEditCancel = () => {
        setIsEditing(false);
        setEditingFilter(null);
        reset();
        setValue("DS_VALOR", "");
    };

    const optionsOperador = [
        { value: "", label: "" },
        { value: "AND", label: "AND" },
        { value: "OR", label: "OR" },
        { value: "=", label: "=" },
        { value: "LIKE", label: "LIKE" },
        { value: "NOT LIKE", label: "NOT LIKE" },
        { value: "IN", label: "IN" },
        { value: "NOT IN", label: "NOT IN" },
        { value: "<", label: "<" },
    ];
    const optionsTipoFiltro = (
        LstEtapaAcaoTipoFiltro ? LstEtapaAcaoTipoFiltro.map((TipoFiltro) => {
            return (
                <option
                    key={TipoFiltro.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO}
                    value={TipoFiltro.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO}
                >
                    {TipoFiltro.DS_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO}
                </option>
            );
        }) : []
    );

    return LstEtapaAcaoTipoFiltro ? (
        <div>
            <form onSubmit={handleSubmit(handleFormSubmit)} className="mb-3">
                <div className="d-flex flew-wrap col-md-12">
                    <div className="mt-2 p-1 col-md-4">
                        <h6>Tipo Filtro:</h6>
                        {isEditing ?
                            <select
                                name="ID_TIPO_FILTRO"
                                className={`form-control placeholder-dark-45 ${formState.errors.ID_TIPO_FILTRO && "is-invalid"
                                    }`}
                                ref={register({
                                    required: "Insira o valor",
                                    valueAsNumber: true,
                                })}
                                value={editingFilter ? LstEtapaAcaoTipoFiltro?.find(tipo => tipo.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO === editingFilter.ID_TIPO_FILTRO)?.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO : 0}
                                onChange={(e) => {
                                    if (editingFilter) {
                                        setEditingFilter({
                                            ...editingFilter,
                                            ID_TIPO_FILTRO: parseInt(e.target.value, 10)
                                        });
                                    }
                                }}
                            >
                                <option></option>
                                {optionsTipoFiltro}
                            </select> :
                            <select
                                name="ID_TIPO_FILTRO"
                                className={`form-control placeholder-dark-45 ${formState.errors.ID_TIPO_FILTRO && "is-invalid"
                                    }`}
                                ref={register({
                                    required: "Insira o valor",
                                    valueAsNumber: true,
                                })}
                            >
                                <option></option>
                                {optionsTipoFiltro}
                            </select>}
                    </div>
                    <div className="mt-2 p-1 col-md-4">
                        <h6>Operação:</h6>
                        {isEditing ? (
                            <select
                                name="DS_OPERADOR"
                                className={`form-control placeholder-dark-45 ${formState.errors.DS_OPERADOR && "is-invalid"}`}
                                ref={register({
                                    required: "Insira o valor",
                                })}
                                value={editingFilter ? editingFilter.DS_OPERADOR : ""}
                                onChange={(e) => {
                                    if (editingFilter) {
                                        setEditingFilter({
                                            ...editingFilter,
                                            DS_OPERADOR: e.target.value
                                        });
                                    }
                                }}
                            >
                                <option></option>
                                {optionsOperador.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        ) : (
                            <select
                                name="DS_OPERADOR"
                                className={`form-control placeholder-dark-45 ${formState.errors.DS_OPERADOR && "is-invalid"}`}
                                ref={register({
                                    required: "Insira o valor",
                                })}
                            >
                                {optionsOperador.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        )}
                    </div>
                    <div className="mt-2 p-1 col-md-4">
                        <h6>Valor:</h6>
                        {isEditing ?
                            <input
                                type="text"
                                name="DS_VALOR"
                                className={`form-control placeholder-dark-45 ${formState.errors.DS_VALOR && "is-invalid"
                                    }`}
                                placeholder="Valor"
                                ref={register({
                                    required: "Insira o valor",
                                })}
                                value={editingFilter ? editingFilter.DS_VALOR : ""}
                                onChange={(e) => {
                                    if (editingFilter) {
                                        setEditingFilter({
                                            ...editingFilter,
                                            DS_VALOR: e.target.value
                                        });
                                    }
                                }}
                            /> :
                            <input
                                type="text"
                                name="DS_VALOR"
                                className={`form-control placeholder-dark-45 ${formState.errors.DS_VALOR && "is-invalid"
                                    }`}
                                placeholder="Valor"
                                ref={register({
                                    required: "Insira o valor",
                                })}
                                defaultValue=""
                            />}
                    </div>
                </div>
                <div className="d-flex flew-column justify-content-end m-2">
                    <div className="d-flex flex-row justify-content-between mr-4">
                        {isEditing ? (
                            <>
                                <button
                                    type="button"
                                    disabled={editingFilter?.DS_VALOR.length === 0 || !editingFilter?.DS_OPERADOR || !editingFilter?.ID_TIPO_FILTRO}
                                    className="btn btn-outline-success font-weight-bold"
                                    onClick={handleEditConfirm}
                                >
                                    Confirmar Edição
                                </button>
                                <div className="ml-2">
                                    <button type="button" className="btn btn-outline-danger font-weight-bold" onClick={handleEditCancel}>
                                        Cancelar Edição
                                    </button>
                                </div>
                            </>
                        ) : (
                            <button className="btn btn-outline-success
                                font-weight-bold
                                d-flex
                                justify-content-center
                                align-items-center"
                            >
                                <FontAwesomeIcon
                                    icon={faPlus}
                                    size="lg"
                                    className="mr-1"
                                />{" "}
                                Cadastrar
                            </button>
                        )}
                    </div>
                </div>
            </form>
            <div className="card card-custom w-auto gutter-b m-5">
                {LstEtapaAcaoFiltro && (
                    <Table
                        columns={columns}
                        data={LstEtapaAcaoFiltro}
                        keyField={"ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO"}
                        noDataIndication={() => (
                            <div className="text-black-50 text-center">
                                Nenhum filtro encontrado
                            </div>
                        )}
                        noSearch
                    />
                )}
            </div>
        </div>
    ) : (
        <SpinnerComponent />
    );
}